import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import styles from './ProfileLoading.module.css'

export const ProtectedRoute = ({ children, user, wasUserLoaded }) => {
  const location = useLocation()

  if (!wasUserLoaded) {
    return <h2 className={styles.loading}>Profil wird geladen ... </h2>
  }
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return <>{React.cloneElement(children, { user })}</>
}
